import React from 'react'
import './safariblog.css'
import { Link } from 'react-router-dom'

const SafariBlog = ({heading, description, to}) => {
  return <div>
    <div className="safari__blog-content w-1">
        <h1 className="__h1">{heading}</h1>
        <span class="dash"></span>
        {Array.isArray(description) ? (
          description.map((desc, index) => <p key={index}>{desc}</p>)
        ) : (
          <p>{description}</p>
        )}
        <Link class="wildlife__plan-link" to={to}>Plan Your Tour</Link>
    </div>
  </div>
}

export default SafariBlog